/**
 * Cart Page Redirect for Custom Pricing Products
 * Redirects users back to checkout if they try to access cart with active custom pricing
 */

// Run immediately without waiting for DOMContentLoaded for faster redirect
function checkAndRedirectCart() {
  // Only run on cart page
  if (window.location.pathname !== '/cart') {
    return;
  }
  
  // Check if there's an active custom pricing checkout
  const hasCustomPricing = localStorage.getItem('custom_pricing_active') === 'true';
  const checkoutUrl = localStorage.getItem('custom_pricing_checkout_url');
  
  if (hasCustomPricing && checkoutUrl) {
    // Immediate redirect if possible
    if (document.readyState === 'loading') {
      // If page is still loading, redirect immediately
      window.location.href = checkoutUrl;
      return;
    }
    // Replace cart content with redirect message
    const cartContainer = document.querySelector('.cart__contents') || 
                         document.querySelector('.cart') || 
                         document.querySelector('#main-cart-items') ||
                         document.querySelector('main');
    
    if (cartContainer) {
      cartContainer.innerHTML = `
        <div style="text-align: center; padding: 3rem; max-width: 600px; margin: 0 auto;">
          <h2 style="margin-bottom: 1rem; color: #333;">Redirecting to Your Custom Order...</h2>
          <p style="margin-bottom: 1rem; color: #666;">You have a custom pricing order in progress.</p>
          <p style="margin-bottom: 2rem; color: #666;">You'll be redirected to complete your purchase.</p>
          
          
          <p style="margin: 2rem 0;">
            <a href="${checkoutUrl}" style="background: #333; color: white; padding: 12px 24px; text-decoration: none; border-radius: 4px; display: inline-block;">
              Continue to Checkout
            </a>
          </p>
          
          <p style="margin: 1rem 0;">
            <button onclick="clearCustomPricing()" style="background: #f44336; color: white; border: none; padding: 10px 20px; border-radius: 4px; cursor: pointer; margin-right: 10px;">
              Cancel Order & Start Over
            </button>
          </p>
          
          <p style="font-size: 0.85em; color: #999;">
            Having issues? <a href="/products/alw-sub?clear_custom_pricing=true" style="color: #666; text-decoration: underline;">Clear this order</a> to start fresh.
          </p>
        </div>
        
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
    }
    
    // Add function to clear custom pricing
    window.clearCustomPricing = function() {
      localStorage.removeItem('custom_pricing_active');
      localStorage.removeItem('custom_pricing_checkout_url');
      window.location.reload();
    };
    
    // User can click Continue to Checkout button if they want to proceed
  }
}

// Run immediately
checkAndRedirectCart();

// Also run when DOM is ready (fallback)
document.addEventListener('DOMContentLoaded', checkAndRedirectCart);

// Clear custom pricing flags when order is completed (on thank you page)
if (window.location.pathname.includes('/thank_you') || window.location.pathname.includes('/orders/')) {
  localStorage.removeItem('custom_pricing_active');
  localStorage.removeItem('custom_pricing_checkout_url');
}